<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="w-100 d-flex flex-row justify-content-between">
          <div>لیست پیام های ارسالی به ادمین</div>
          <v-btn class="float-left" color="primary"  @click="returnToTradeRequestList()">بازگشت به لیست درخواست ها</v-btn>

        </div>
             </v-card-title>
      <v-divider> </v-divider>
      <v-card-text>
        <trade-request-chats-with-admin-list
          :tradeRequestChatWithAdminList="tradeRequestChatWithAdminList"
          @getTradeRequestChatsWithAdmin="getTradeRequestChatsWithAdmin"
        >
        </trade-request-chats-with-admin-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TradeRequestChatsWithAdminList from '../components/TradeRequestChatsWithAdminList.vue';
import Helper from '@/core/helpers';
const tradeRequestChatWithAdminRepository = () =>
  RepoFactory.get('tradeRequestChatWithAdmin');
import { RepoFactory } from '@/baseRepository/Factory';
export default {
  components: {
    TradeRequestChatsWithAdminList,
  },
  data() {
    return { tradeRequestChatWithAdminList: [] };
  },
  computed: {
    baseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    id() {
      return this.$route.params.id;
    },
  },
  created() {
    this.getTradeRequestChatsWithAdmin();
  },
  methods: {
    returnToTradeRequestList(){
      this.clearStore()
      this.$router.push({ path: `/trade-request` })
    },
    clearStore(){
      this.$store.commit('setTradeRequestFormStatus',false )
      this.$store.commit('setTradeRequestIsEdit',false )
      this.$store.commit('setTradeRequestSelectedForEdit',null )
      this.$store.commit('setTradeRequestShowDetailForm',false )
      this.$store.commit('setTradeRequestSingleItem',null )
      this.$store.commit('setTradeRequestSingleItemForEdit',null )
      this.$store.commit('setTradeRequestItems',[] )
      this.$store.commit('setTradeRequestSelectedForDisplay',null )
      this.$store.commit('setTradeRequestCategoryType',null )
      this.$store.commit('setTradeRequestEditMode',false )
      this.$store.commit('setTradeRequestResponsesPerItem',null )
      this.$store.commit('setTradeRequestNumber',null )
      this.$store.commit('setTradeRequestDate',null )
      this.$store.commit('setTradeRequestResponsesHeader',null )
      this.$store.commit('setTradeRequestSelectedForResponse',null )

  },
    getTradeRequestChatsWithAdmin() {
      const loader = this.$loading.show();
      let param = {
        tradeRequestId: this.id,
      };
      tradeRequestChatWithAdminRepository()
        .getTradeRequestChatsWithAdmin(this.baseUrl, {}, param)
        .then((res) => {
          this.tradeRequestChatWithAdminList = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style lang="scss" scoped></style>
